var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHedgeBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M35 22C28 17 17 15 8 17v31c9-2 20 0 27 5m0-36c7-5 18-7 27-5v31c-9-2-20 0-27 5m0-36v36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    stroke: "none",
    d: "M-4-13H4V-4H13V4H4V13H-4V4H-13V-4H-4Z",
    transform: "translate(48 34) rotate(45) scale(.52)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHedgeBook);
export default __webpack_public_path__ + "static/media/hedgeBook.c0609d9723c4cb06ba4ff400e68e80e3.svg";
export { ForwardRef as ReactComponent };